<template>
  <v-dialog
    persistent
    v-model="displayDialog"
    width="500">
    <ValidationObserver
      :disabled="true"
      ref="flight"
      v-slot="{ invalid, valid, errors }">
      <v-form v-model="flightValid">
        <v-card>
          <v-toolbar
            v-if="showAlert"
            color="red"
            dark>{{ alertText }}</v-toolbar>
          <v-card-title>
            <span class="headline">Add flight</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col>
                  <ValidationProvider
                    rules="required"
                    name="Carrier"
                    vid="carrierId"
                    v-slot="{ errors }">
                    <v-select
                      :error-messages="errors"
                      :items="CARRIERS"
                      item-text="name"
                      item-value="id"
                      label="Carrier"
                      outlined
                      dense
                      v-model="editedItem.carrierId">
                    </v-select>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <ValidationProvider
                    rules="required"
                    name="Flight number"
                    vid="flightNumber"
                    v-slot="{ errors }">
                    <v-text-field
                      v-model="editedItem.flightNumber"
                      :error-messages="errors"
                      label="Flight #"
                      append-icon="mdi-card-bulleted-outline"
                      placeholder="Enter Flight #">
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-text-field
                    label="Flight time"
                    value="12:30:00"
                    type="time"
                    v-model="editedItem.flightTime"
                    suffix="AEST">
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <v-switch
                  v-model="editedItem.isDomestic"
                  label="Is domestic flight"
                  color="primary"
                  hide-details>
                  </v-switch>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-switch
                  v-model="editedItem.isDeparting"
                  label="Is departing flight"
                  color="primary"
                  hide-details>
                  </v-switch>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <ValidationProvider
                    rules="required"
                    name="Other airport"
                    vid="otherAirport"
                    v-slot="{ errors }">
                    <v-text-field
                      v-model="editedItem.otherAirport"
                      :error-messages="errors"
                      label="Other airport"
                      append-icon="mdi-card-bulleted-outline"
                      placeholder="Enter other airport">
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <ValidationProvider
                    rules="required"
                    name="Terminal"
                    vid="terminal"
                    v-slot="{ errors }">
                    <v-text-field
                      v-model="editedItem.terminal"
                      :error-messages="errors"
                      label="Terminal"
                      append-icon="mdi-card-bulleted-outline"
                      placeholder="Enter terminal">
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="closeFlight">
              Cancel
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="saveFlight">
              Done
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </ValidationObserver>
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
// import { mapFields } from 'vuex-map-fields';
// import storeConstants from '@/store/storeConstants';
import
{
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import storeConstants from '@/store/storeConstants';

setInteractionMode('eager');
extend('required', required);

export default {
  name: 'Flight',
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    showAlert: false,
    alertText: undefined,
    flightValid: false,
    editedItem: {},
    defaultItem: {
      carrierId: undefined,
      flightNumber: undefined,
      isDomestic: undefined,
      flightTime: undefined,
      isDeparting: undefined,
      otherAirport: undefined,
      terminal: undefined,
    },
  }),
  watch: {
    value: {
      handler(val, oldVal) {
        if (val === true && oldVal === false) {
          this.addNewFlight();
          // console.log('Prop changed: ', newVal, ' | was: ', oldVal);
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters([
      storeConstants.CARRIERS,
    ]),
    displayDialog: {
      get() {
        // returns the value of your prop
        return this.value;
      },
      set(newValue) {
        // v-model listens to the input event, so emitting `input` with a value
        // will update the model with that value
        this.$emit('input', newValue);
      },
    },
  },
  methods: {
    ...mapActions([
      storeConstants.GET_CARRIERS,
      storeConstants.SAVE_FLIGHT,
      storeConstants.SET_ALERT_DETAILS]),
    addNewFlight() {
      this.GET_CARRIERS();
      this.editedItem = Object.assign({}, this.defaultItem);
    },
    saveFlight() {
      this.showAlert = false;
      this.alertText = undefined;
      this.$refs.flight.validate().then((success) => {
        this.flightValid = success;
        if (this.flightValid) {
          this.SAVE_FLIGHT(this.editedItem)
            .then((response) => {
              if (response) {
                this.displayDialog = false;
              } else {
                this.alertText = 'Saving flight failed.  Does this flight already exist?';
                this.showAlert = true;
              }
            });
        }
      });
    },
    closeFlight() {
      this.displayDialog = false;
    },
  },
};
</script>
